export const memesEnabled = () => true
